import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./integrationTelegram.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../LandingPage/Footer";
import requestIntegration from "../../Assets/requestIntegration.png";
import aiTraining from "../../Assets/aiTraining.png";
import goLiveIntegrate from "../../Assets/goLiveIntegrate.png";
import instantReplyMsgIcon from "../../Assets/instantReplyMsgIcon.png";
import aiTrainedOnData from "../../Assets/aiTrainedOnData.png";
import SecureReliable from "../../Assets/SecureReliable.png";

const IntegrationTelegram = () => {
  const [chatIndex, setChatIndex] = useState(0);
  const navigate = useNavigate();

  const chats = [
    { user: "user", text: "Hey" },
    { user: "bot", text: "Hello! How can I assist you today?" },
    { user: "user", text: "Do I need technical knowledge?" },
    { user: "bot", text: "No. We handle setup, hosting, and AI training." },
    { user: "bot", text: "You'll be live in minutes 🚀" },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setChatIndex(prev => (prev < chats.length ? prev + 1 : prev));
    }, 600);
    return () => clearInterval(timer);
  }, [chats.length]);

  const handleLearMoreButton = () => {
    window.open("/docs#telegram-whatsApp-integration", "_blank");
  };

  return (
    <div className="tele-page">
      <div className="tele-navbar-bg">
        <Navbar />
      </div>

      {/* Hero Section */}
      <section className="tele-hero">
        <div className="tele-hero-container">
          <div className="tele-hero-left">
            <h1>
              Telegram Bot Integration with{" "}
              <span className="tele-highlight">XenaChat</span>
            </h1>
            <p className="tele-hero-subtitle">
              Automate Telegram conversations with powerful AI — no coding, no
              setup headaches. Deploy intelligent chatbots in minutes.
            </p>

            <div className="tele-steps">
              <div className="tele-step">
                <div className="tele-step-icon">
                  <img src={requestIntegration} alt="Request Integration" />
                </div>
                <span>Request Integration</span>
              </div>
              <div className="tele-step">
                <div className="tele-step-icon">
                  <img src={aiTraining} alt="AI Training" />
                </div>
                <span>AI Training</span>
              </div>
              <div className="tele-step">
                <div className="tele-step-icon">
                  <img src={goLiveIntegrate} alt="Go Live" />
                </div>
                <span>Go Live</span>
              </div>
            </div>

            <div className="tele-btn-group">
              <button
                className="tele-btn-primary"
                onClick={() => navigate("/bookDemo")}
              >
                Schedule a Demo
              </button>
              <button className="tele-btn-secondary" onClick={ handleLearMoreButton }>Learn More</button>
            </div>

            <div className="tele-trust-indicators">
              <div className="tele-trust-item">
                <strong>Enterprise-Ready</strong> Infrastructure
              </div>
              <div className="tele-trust-item">
                <strong>99.9%</strong> Uptime
              </div>
              <div className="tele-trust-item">
                <strong>24/7</strong> Support
              </div>
            </div>
          </div>

          {/* Bot UI in Phone */}
          <div className="tele-hero-right">
            <div className="tele-phone">

              <div className="tele-phone-header">
                <div className="tele-header-content">
                  <div className="tele-back-btn">←</div>
                  <div className="tele-bot-avatar">X</div>
                  <div className="tele-bot-info">
                    <div className="tele-bot-name">XenaChat Bot</div>
                    <div className="tele-bot-status">Online</div>
                  </div>
                </div>
              </div>

              <div className="tele-chat-area">
                <div className="tele-date-divider">Today</div>
                {chats.slice(0, chatIndex).map((chat, index) => (
                  <div
                    key={index}
                    className={`tele-chat-bubble ${chat.user === "bot" ? "tele-bot" : "tele-user"
                      }`}
                  >
                    {chat.text}
                    <div className="tele-message-time">
                      {new Date().toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </div>
                ))}
                {chatIndex < chats.length && (
                  <div className="tele-typing-container">
                    <div className="tele-typing">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                )}
              </div>

              <div className="tele-phone-input">
                <div className="tele-input-field">
                  <span className="tele-emoji-btn">😊</span>
                  <span className="tele-placeholder">Message…</span>
                  <span className="tele-send-btn">➤</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="tele-feature-section">
        <div className="tele-container">
          <div className="tele-section-header">
            <h2>Why XenaChat + Telegram</h2>
            <p className="tele-section-subtitle">
              Everything you need to automate Telegram conversations at scale
              with enterprise-grade reliability
            </p>
          </div>

          <div className="tele-feature-grid">
            <div className="tele-feature-card">
              <div className="tele-feature-icon">
                <img src={instantReplyMsgIcon} alt="Instant Replies" />
              </div>
              <h4>Instant Replies</h4>
              <p>
                Respond to customers 24/7 with AI-driven conversations. Never
                miss a message, even during peak hours.
              </p>
            </div>

            <div className="tele-feature-card">
              <div className="tele-feature-icon">
                <img src={aiTrainedOnData} alt="AI Trained on Your Data" />
              </div>
              <h4>AI Trained on Your Data</h4>
              <p>
                Train bots using FAQs, documents, and your knowledge base.
                Delivers accurate, context-aware responses.
              </p>
            </div>

            <div className="tele-feature-card">
              <div className="tele-feature-icon">
                <img src={SecureReliable} alt="Secure & Reliable" />
              </div>
              <h4>Secure & Reliable</h4>
              <p>
                Enterprise-grade security with scalable infrastructure. SOC 2
                compliant with 99.9% uptime guarantee.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* AI-Powered Section */}
      <section className="tele-ai-section">
        <div className="tele-container">
          <h2>
            Unlock <span className="tele-gradient-text">AI-Powered</span>{" "}
            Customer Support
          </h2>
          <p className="tele-ai-description">
            Reduce ticket volume by 70%, improve response time by 10x, and
            deliver consistent experiences—all while reducing operational costs.
          </p>

          <div className="tele-stats-grid">
            <div className="tele-stat-card">
              <div className="tele-stat-number">70%</div>
              <div className="tele-stat-label">Reduction in Support Tickets</div>
            </div>
            <div className="tele-stat-card">
              <div className="tele-stat-number">10x</div>
              <div className="tele-stat-label">Faster Response Time</div>
            </div>
            <div className="tele-stat-card">
              <div className="tele-stat-number">95%</div>
              <div className="tele-stat-label">Customer Satisfaction</div>
            </div>
          </div>
        </div>
      </section>

      <section id="how-it-works" className="tele-process-section">
        <div className="tele-container">
          <div className="tele-section-header">
            <h2>How It Works</h2>
            <p className="tele-section-subtitle">
              Effortless integration in 3 simple steps—no technical expertise
              required
            </p>
          </div>

          <div className="tele-process-grid">
            <div className="tele-process-card">
              <div className="tele-process-icon">
                <img src={requestIntegration} alt="Connect" />
              </div>
              <span className="tele-step-number">01</span>
              <h4>Connect</h4>
              <p>
                Request Telegram bot integration through our simple form. We'll
                securely set up your bot token and configure the connection.
              </p>
            </div>

            <div className="tele-process-card">
              <div className="tele-process-icon">
                <img src={aiTraining} alt="Train" />
              </div>
              <span className="tele-step-number">02</span>
              <h4>Train</h4>
              <p>
                Upload your knowledge base, FAQs, and documents. Our AI learns
                your brand voice and customizes responses to match your needs.
              </p>
            </div>

            <div className="tele-process-card">
              <div className="tele-process-icon">
                <img src={goLiveIntegrate} alt="Launch" />
              </div>
              <span className="tele-step-number">03</span>
              <h4>Launch</h4>
              <p>
                Go live instantly and start supporting customers. Monitor
                performance, refine responses, and scale effortlessly.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="pricing" className="tele-cta-section">
        <div className="tele-cta-card">
          <h2>Ready to Transform Your Support?</h2>
          <p>
            Join thousands of businesses using XenaChat's AI-powered Telegram
            bot to deliver exceptional customer experiences at scale.
          </p>

          <div className="tele-btn-group tele-btn-center">
            <button className="tele-btn-cta-primary" onClick={() => navigate("/bookDemo")}>
              Schedule a Demo
            </button>
            <button
              className="tele-btn-cta-secondary"
              onClick={() => {
                window.location.href =
                  "mailto:support@xenachat.com?subject=Support%20Request&body=Hi%20Support%20Team,%0D%0A%0D%0AI%20need%20help%20with...";
              }}
            >
              Contact Support
            </button>
          </div>

          <div className="tele-cta-trust">
            <span>✓ No credit card required</span>
            <span>✓ Free 14-day trial</span>
            <span>✓ Cancel anytime</span>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default IntegrationTelegram;